import { useContext } from 'react'

import { Form } from 'components/ui/form/Form'
import KitForm from 'components/parts/KitForm'
import { kitWithItemsValidation } from 'util/validations'
import { useAddKit } from 'hooks/mutations'
import { DocumentTextIcon } from '@heroicons/react/24/outline'
import { ModalContext } from 'context/ModalContext'
import { Card } from 'components/gsys-ui'

const AddKitModal = ({ initial }) => {
  const modal = useContext(ModalContext)
  console.log(initial)
  const mutation = useAddKit()

  return (
    <Card className="m-auto">
      <Card.Title Icon={DocumentTextIcon}>Add a kit</Card.Title>
      <Card.Body>
        <Form
          validation={kitWithItemsValidation}
          initial={initial}
          mutation={mutation}
          FormComp={KitForm}
          onSubmit={modal.close}
        />
      </Card.Body>
    </Card>
  )
}

export default AddKitModal